import { useEffect, useRef } from "react";

/**
 * Executa a função periodicamente. Pausa quando a aba não está visível.
 * Uso: useAutoRefresh(loadData, 30000)  // refresca a cada 30s
 */
export function useAutoRefresh(callback, intervalMs = 30000) {
  const cbRef = useRef(callback);
  useEffect(() => { cbRef.current = callback; }, [callback]);

  useEffect(() => {
    if (!intervalMs || intervalMs <= 0) return;
    const tick = () => {
      if (document.visibilityState === "visible") {
        try { cbRef.current?.(); } catch { /* ignore */ }
      }
    };
    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}
